import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Login from '../components/dashboard/Login';
import Auth from '../components/dashboard/Auth';
import { FaSpinner } from 'react-icons/fa';
import logo2 from '../img/logo.png';
import UserCards from '../components/UserCards';
import translations from '../translations';
import NavBar from '../components/NavBar';

function Dashboard() {
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];
  
  const logOut = () => {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('token');
    window.location.reload();
  };

  return (
    <div>
      <Helmet>
        <title>{t.dashboardTitle} | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div>
        <Auth setLogin={setLogin} />
        {login ? 
          (
            <div>
              {loading && (<div className="fixed inset-0 h-screen w-full bg-white bg-opacity-80 flex flex-col items-center justify-center space-y-5">
                <FaSpinner className="text-4xl text-black animate-spin" />
                <img src={logo2} alt="Logo" className="h-10 mb-4" />
              </div>)}
              <NavBar />
              <div className="md:p-24 py-24 flex items-center justify-center">
                <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-lg w-full">
                  <UserCards setLoading={setLoading} />
                  <button 
                  onClick={logOut}
                  className='mt-8 w-full text-neutral-50 px-5 py-3 rounded-lg bg-red-400 hover:bg-red-500'>
                    {t.logout}
                  </button>
                </div>
              </div>
            </div>
          ) : ( 
            <div>
              <Login />
            </div>
          )
        }
      </div>
    </div>
  );
}

export default Dashboard;
